/**
 * Sentinel value used in the validation modal to indicate a cell value should
 * be removed (set to empty string) rather than mapped to a real option.
 */
export const FB_REMOVE_CELL_VALUE = '__FB_REMOVE_CELL_VALUE__'
